import { BuildClass, Do, clamp, timer } from '../../../universal';
import { React, _ } from '../../lib';
import { isDarkTheme } from '../component-main';
import { ConditionalObject } from './meta-types';
const MOUSEPAUSEOPENCONTEXTMENU = 100;
const CONTEXT_MENU_HEIGHT_ROW = () => (window.innerWidth <= 1024 ? 37 : 23);
const CONTEXT_MENU_HEIGHT_DIVIDER = 11;
const CONTEXT_MENU_HEIGHT_PADDING = 6;
const DEFAULT_WIDTH = 240;
export const ContextMenuWrapper = (props) => {
    const onClose = React.useCallback(() => {
        props.data?.onClose?.();
        props.onClose();
    }, [props.data?.onClose, props.onClose]);
    if (props.data == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "tailwind-wrapper", style: { width: '100vw', height: '100vh' } },
        React.createElement("div", { className: BuildClass({
                'fixed top-0 left-0 w-full h-full z-[99999]': true,
                'transition-[background] duration-[100]': true,
                'select-none': true,
                'bg-[hsla(0,0%,0%,0.1)]': props.data != null,
                'pointer-events-none bg-[hsla(0,0%,0%,0)]': !(props.data != null),
            }), onClick: onClose }, ConditionalObject(props.data != null, () => (React.createElement(ContextMenu, { key: "context-menu", position: props.data.position, width: props.data.width, items: props.data.items, onClose: onClose }))))));
};
const ContextMenu = (props) => {
    const [opened, setOpened] = React.useState([]);
    const [isInstantiated, setIsInstantiated] = React.useState(false);
    const [, setIncrement] = React.useState(0);
    React.useEffect(() => {
        setIsInstantiated(true);
        return () => {
            setIsInstantiated(false);
        };
    }, []);
    React.useEffect(() => {
        setOpened([]);
    }, [props.items]);
    return buildBox({
        items: props.items,
        root: true,
        path: [],
        x1: props.position?.x ?? 0,
        x2: props.position?.x ?? 0,
        y1: props.position?.y ?? 0,
        y2: props.position?.y ?? 0,
        width: props.width ?? DEFAULT_WIDTH,
        isInstantiated: isInstantiated,
        prefer_left: props.position?.preferLeft ?? false,
        opened: opened,
        onClose: props.onClose,
        setOpened: setOpened,
        rerender: () => {
            setIncrement(x => x + 1);
        },
    });
};
const buildBox = (obj) => {
    const items = getItems(obj.items);
    let cummulativeHeight = 0;
    const cummulativeHeights = [0];
    _.forEach(items, x => {
        cummulativeHeight +=
            typeof x === 'string'
                ? CONTEXT_MENU_HEIGHT_DIVIDER
                : CONTEXT_MENU_HEIGHT_ROW();
        cummulativeHeights.push(cummulativeHeight);
    });
    const D = getDimensions({
        root: obj.root,
        width: obj.width,
        height: cummulativeHeight + CONTEXT_MENU_HEIGHT_PADDING + 1,
        x1: obj.x1,
        x2: obj.x2,
        y1: obj.y1,
        y2: obj.y2,
        prefer_left: obj.prefer_left ?? false,
    });
    if (!items || items.length == 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: BuildClass({
            'fixed py-[3px] px-0': true,
            'text-[14px]': true,
            'bg-[#ffffff]': true,
            'border-t-[1px] border-l-[1px] border-r-0 border-b-0 border-solid border-[#888]': true,
            'rounded-[5px]': true,
            'shadow-[3px_3px_5px_#444]': true,
            'transition-transform duration-[50ms]': true,
            'overflow-y-auto': true,
            'max-lg:leading-[37px]': true,
            'scale-0': !obj.isInstantiated && obj.root,
            'bg-[hsl(225,8%,10%)] text-[#bbb] border-[#444] shadow-[3px_3px_5px_#222]': isDarkTheme(),
        }), style: {
            left: `${D.left}px`,
            top: `${D.top}px`,
            width: `${D.width}px`,
            height: `${D.height}px`,
            transformOrigin: D.transformOrigin,
        } }, _.map(items, (x, i) => {
        if (isSeparator(x)) {
            return (React.createElement("div", { key: `separator-${i}`, className: "p-[5px] cursor-default", onClick: e => {
                    e.stopPropagation();
                } },
                React.createElement("div", { className: "border-t-[1px] border-solid border-[#ddd]" })));
        }
        const item_key = x.key ?? i;
        const this_path = obj.path.concat(item_key);
        const is_open = _.isEqual(this_path, obj.opened.slice(0, this_path.length));
        return (React.createElement("div", { key: item_key, className: "relative w-full", onClick: e => {
                if (x.onClick == null || x.disabled) {
                    e.stopPropagation();
                    return;
                }
                x.onClick?.(e);
                const closing = !(x.dontClose ?? false);
                if (closing) {
                    obj.onClose();
                }
                else {
                    obj.rerender();
                    e.stopPropagation();
                }
            } },
            ConditionalObject(is_open, buildBox({
                ...obj,
                items: x.items ?? [],
                root: false,
                path: this_path,
                x1: D.left,
                x2: D.left + D.width,
                y1: D.top + (cummulativeHeights[i] ?? 0),
                y2: D.top + (cummulativeHeights[i] ?? 0),
                width: x.childWidth ?? DEFAULT_WIDTH,
                prefer_left: D.went_left,
            })),
            React.createElement(ContextMenuLine, { key: "line", item: x, onHover: () => {
                    obj.setOpened(this_path);
                } })));
    })));
};
export const ContextMenuLine = (props) => {
    const isMouseInside = React.useRef(false);
    const mounted = React.useRef(false);
    const delayedOpenTimer = React.useRef(null);
    React.useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);
    const onMouseOver = () => {
        isMouseInside.current = true;
        if (delayedOpenTimer.current) {
            clearTimeout(delayedOpenTimer.current);
        }
    };
    const onMouseLeave = () => {
        isMouseInside.current = false;
        if (delayedOpenTimer.current) {
            clearTimeout(delayedOpenTimer.current);
        }
    };
    const onMouseMove = () => {
        if (delayedOpenTimer.current) {
            clearTimeout(delayedOpenTimer.current);
        }
        delayedOpenTimer.current = timer(MOUSEPAUSEOPENCONTEXTMENU, () => {
            if (mounted.current) {
                props.onHover?.();
            }
        });
    };
    const onClick = () => {
        if (delayedOpenTimer.current) {
            clearTimeout(delayedOpenTimer.current);
        }
        props.onHover?.();
    };
    const isDark = isDarkTheme();
    const lbl = _.isFunction(props.item.label) ? props.item.label() : props.item.label;
    return (React.createElement("div", { className: BuildClass({
            'flex items-center': true,
            'cursor-pointer': !(props.item.disabled ?? false),
            'cursor-default text-[#aaa]': props.item.disabled ?? false,
            'hover:bg-[hsl(225,8%,20%)]': isDark,
            'hover:bg-[#ddd]': !isDark,
        }), title: props.item.labelDesc ?? lbl, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onClick: onClick },
        React.createElement("div", { className: BuildClass([
                'relative w-[26px] h-[23px] p-[3px_5px]',
                'max-lg:h-[37px] max-lg:py-[10px]',
            ]) }, ConditionalObject(props.item.icon != null, React.createElement("img", { className: BuildClass({
                'absolute top-1/2 left-1/2 max-w-[16px] max-h-[16px]': true,
                'transform -translate-x-1/2 -translate-y-1/2': true,
                'opacity-80': isDark,
                'filter grayscale': Boolean(props.item.iconGrayscale),
                'filter invert': Boolean(props.item.iconGrayscale) && isDark,
            }), src: _.isFunction(props.item.icon)
                ? props.item.icon()
                : props.item.icon }))),
        React.createElement("div", { className: "flex-1 truncate px-[1px]" }, lbl),
        React.createElement("div", { className: BuildClass([
                'px-[1px] pt-[1px] pb-0',
                'text-[12px] leading-[22px] text-right text-[#666]',
            ]), title: props.item.shortcutDesc }, props.item.shortcut),
        React.createElement("div", { className: "w-[16px]" }, ConditionalObject(props.item.items != null, React.createElement("img", { className: BuildClass({
                'w-[10px]': true,
                'opacity-80 filter invert': isDark,
                'opacity-70': !isDark,
            }), src: "/static/img/svg/arrow-right.svg" })))));
};
const getItems = (propsItems) => {
    let items = [];
    if (propsItems == null) {
        return null;
    }
    items = _.compact(_.isFunction(propsItems) ? propsItems() : _.clone(propsItems));
    items = _.filter(items, x => x != null);
    items = _.filter(items, x => typeof x === 'string' || !x.hidden);
    if (typeof items[0] === 'string') {
        items = items.slice(1);
    }
    if (typeof items[items.length - 1] === 'string') {
        items.pop();
    }
    return items;
};
const isSeparator = (item) => {
    if (typeof item !== 'string') {
        return false;
    }
    else if (_.isEqual(_.uniq(item), ['-'])) {
        return true;
    }
    console.error('Item is not an object nor a separator', item);
    return false;
};
const getDimensions = (args) => {
    let { x1, y1, x2, y2, height } = args;
    const { root, width, prefer_left } = args;
    x1 = clamp(x1, 0, window.innerWidth);
    x2 = clamp(x2, 0, window.innerWidth);
    y1 = clamp(y1, 0, window.innerHeight);
    y2 = clamp(y2, 0, window.innerHeight);
    const left = Do(() => {
        if (x2 + width > window.innerWidth) {
            return x1 - width;
        }
        else if (x1 - width < 0) {
            return x2;
        }
        else if (prefer_left) {
            return x1 - width;
        }
        return x2;
    });
    let top = y2 + height > window.innerHeight ? y1 - height : y2;
    const transform_x = left < x1 ? 'right' : 'left';
    const transform_y = top < y1 ? 'bottom' : 'top';
    const transformOrigin = `${transform_x} ${transform_y}`;
    const went_left = left < x1;
    if (!root && transform_y === 'bottom') {
        top += CONTEXT_MENU_HEIGHT_ROW() + CONTEXT_MENU_HEIGHT_PADDING;
    }
    const max_height = window.innerHeight - CONTEXT_MENU_HEIGHT_PADDING * 4;
    if (height > max_height) {
        height = max_height;
        top = CONTEXT_MENU_HEIGHT_PADDING * 2;
    }
    else if (top < CONTEXT_MENU_HEIGHT_PADDING * 2) {
        top = CONTEXT_MENU_HEIGHT_PADDING * 2;
    }
    return { width, height, left, top, transformOrigin, went_left };
};
export const setContextMenu = (obj) => {
    const rui = window.rootUI;
    if (typeof rui !== 'undefined' && rui !== null) {
        rui.setContextMenu(obj);
    }
    else {
        console.error('Cannot open a context menu on a non-frame page');
    }
};
//# sourceMappingURL=context-menu.js.map